import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { ShieldCheck, UserPlus, LogIn } from 'lucide-react';

export default function AcceptInvite() {
  const [params] = useSearchParams();
  const email = params.get('email') || '';

  return (
    <div className="min-h-screen bg-[#0d0d0f] pt-16 flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center">
        <div className="w-16 h-16 bg-primary/10 flex items-center justify-center mx-auto mb-6">
          <ShieldCheck className="w-8 h-8 text-primary" />
        </div>
        <p className="text-primary text-xs font-bold tracking-widest mb-2">ADMIN INVITATION</p>
        <h1 className="text-white font-black text-3xl uppercase mb-3">Set up your admin account</h1>
        <p className="text-white/40 text-sm mb-8 leading-relaxed">
          You've been invited to join Motion Reality as an administrator.
          {email ? <> Please use <span className="text-white font-bold">{email}</span> when creating your account.</> : null}
        </p>
        <div className="flex flex-col gap-3">
          <Link
            to={`/account?invite=admin${email ? `&email=${encodeURIComponent(email)}` : ''}`}
            className="flex items-center justify-center gap-2 bg-primary hover:bg-primary/90 text-white font-bold text-sm py-4 transition-colors"
          >
            <UserPlus className="w-4 h-4" /> CREATE YOUR ACCOUNT
          </Link>
          <Link
            to="/account"
            className="flex items-center justify-center gap-2 border border-white/10 hover:border-white/25 text-white/60 hover:text-white font-bold text-sm py-4 transition-all"
          >
            <LogIn className="w-4 h-4" /> I ALREADY HAVE AN ACCOUNT
          </Link>
        </div>
      </div>
    </div>
  );
}